module.exports = __webpack_public_path__ + "static/media/anshul_shelokar.af36bb8e.png";